module.exports = __webpack_public_path__ + "media/images/new_landing/hp/radek-finkous-afd3ff8f83a1df39c5b7a8278ae20ec8.jpeg";